import { Utils } from './Utils.js';
import { OclParser } from './parser/OclParser.js';
export class OclExecutionContext {
    constructor(obj) {
        this.obj = obj;
        this.evaluationResult = undefined;
        this.failedInvariants = [];
        this.evaluatedContexts = [];
        this.labelsToExecute = [];
        this.staticRegistry = new Map();
        this.targetTypeName = Utils.getClassName(obj);
        this.registeredTypes = OclParser.registeredTypes;
    }
    addFailedInvariant(inv) {
        this.failedInvariants.push(inv);
    }
    setObjectToEvaluate(obj) {
        this.obj = obj;
        return this;
    }
    getObjectToEvaluate() {
        return this.obj;
    }
    getRegisteredType(targetTypeName) {
        return this.registeredTypes[targetTypeName];
    }
    setTargetTypeName(name) {
        this.targetTypeName = name;
    }
    getTargetTypeName() {
        return this.targetTypeName;
    }
    registerTypes(types) {
        this.registeredTypes = Object.assign(Object.assign({}, this.registeredTypes), types);
    }
    setRegisteredEnumerations(enumerations) {
        this.registeredEnumerations = Object.assign(Object.assign({}, this.registeredEnumerations), enumerations);
    }
    getRegisteredEnumeration(key) {
        return this.registeredEnumerations[key] || [];
    }
    getFailedInvariants() {
        return this.failedInvariants;
    }
    getLabelsToExecute() {
        return this.labelsToExecute;
    }
    getEvaluationResult() {
        return this.evaluationResult;
    }
    setEvaluationResult(evaluationResult) {
        this.evaluationResult = evaluationResult;
    }
    addEvaluatedContext(context) {
        this.evaluatedContexts.push(context);
    }
    getEvaluatedContexts() {
        return this.evaluatedContexts;
    }
    getStatic(source) {
        return this.staticRegistry.has(source) ? this.staticRegistry.get(source) : {};
    }
    enrichStatic(typeName, key, value) {
        if (!this.staticRegistry.has(typeName)) {
            this.staticRegistry.set(typeName, {});
        }
        this.staticRegistry.get(typeName)[key] = value;
    }
    registerStatics(staticAPI) {
        this.staticRegistry = staticAPI;
    }
}
//# sourceMappingURL=OclExecutionContext.js.map